<script setup lang="ts">
import { useMediaQuery } from "@vueuse/core"
import { PopoverArrow, PopoverClose, PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger } from "reka-ui"
import { watch } from "vue"
import { Icon } from "@/components/ui"
import { useTranslation } from "@/composables"

defineProps<{
  title: string
}>()

const { t } = useTranslation()
const popoverOpen = defineModel<boolean>("popoverOpen", { default: false })
const isMobileView = useMediaQuery("(max-width: 767px)")

watch(isMobileView, (mobile) => {
  if (!mobile)
    popoverOpen.value = false
})
</script>

<template>
  <PopoverRoot
    v-if="isMobileView"
    v-model:open="popoverOpen"
  >
    <PopoverTrigger as-child>
      <span
        class="line-clamp-1 min-w-0 cursor-pointer overflow-hidden underline decoration-dotted underline-offset-2"
        data-test="album_title"
        :aria-expanded="popoverOpen"
        @click.stop
      >
        {{ title }}
      </span>
    </PopoverTrigger>
    <PopoverPortal>
      <PopoverContent
        class="z-50 max-w-[min(20rem,calc(100vw-2rem))] select-none wrap-break-word whitespace-normal rounded-md border bg-white px-3.75 py-2.5 text-sm leading-snug shadow-sm"
        :side-offset="6"
        side="top"
        data-test="album_title_full"
        @open-auto-focus.prevent
      >
        <div class="flex items-start gap-2">
          <span class="min-w-0 flex-1">{{ title }}</span>
          <PopoverClose
            class="cursor-pointer border-none bg-transparent p-0 text-gray-500"
            :aria-label="t('close')"
            data-test="album_title_close"
          >
            <Icon icon="Close" size="xs" />
          </PopoverClose>
        </div>
        <PopoverArrow
          class="fill-white stroke-gray-200"
          :width="12"
          :height="6"
        />
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
  <span
    v-else
    class="line-clamp-1 min-w-0 overflow-hidden"
    data-test="album_title"
  >
    {{ title }}
  </span>
</template>
